// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { AppConstants, LMFormType } from '@utils/app.constants';
import { LMContextService } from '@services/lm-context.service';

@Injectable()
export class LMFormSpecUtilService {

  constructor(private lmContextService: LMContextService) {}

  public formName(formSpec?: LMFormSpec): string {
    return (formSpec) ? formSpec.busFormSpec.name : '';
  }

  public formNamePrefix(formSpec?: LMFormSpec): string {
    return (formSpec && formSpec.busFormSpec && formSpec.busFormSpec.namePrefix) ? formSpec.busFormSpec.namePrefix : '';
  }

  public isActionForm(formSpec?: LMFormSpec): boolean {
    return (formSpec && formSpec.busFormSpec.formType === LMFormType.ACTION);
  }

  public isActionFormWithSections(formSpec: LMFormSpec) {
    return this.isActionForm && formSpec.busFormSpec.panels;
  }

  public isBusinessTask(formSpec: LMFormSpec): boolean {
    return (formSpec && formSpec.busClassSpec && formSpec.busClassSpec.isBusTask)
  }

  public isChangePasswordForm(formSpec?: LMFormSpec): boolean {
    return (formSpec && formSpec.busFormSpec.name === 'ChangePasswordUIMenuForm');
  }

  public isCompactForm(formSpec?: LMFormSpec): boolean {
    return (formSpec && formSpec.busFormSpec.subFormType
      && formSpec.busFormSpec.subFormType === AppConstants.FORMSUBTYPE_COMPOUNDFLD
    );
  }

  public isContextForm(formSpec?: LMFormSpec): boolean {
    return (formSpec && formSpec.isContextForm) ? true : false;
  }

  public isContextFormOnSide(formSpec?: LMFormSpec): boolean {
    return (formSpec && formSpec.isContextForm && formSpec.busFormSpec && formSpec.busFormSpec.showContextFormOnLeft);
  }

  public isCompositeForm(formSpec?: LMFormSpec): boolean {
    return (formSpec
      && (formSpec.busFormSpec.formType === LMFormType.COMPOSITE || this.isActionFormWithSections(formSpec))
      && !formSpec.busFormSpec.panelNavigation
      && !formSpec.busFormSpec.isWizard);
  }

  public isDetailFieldsForm(formSpec?: LMFormSpec): boolean {
    return (formSpec && formSpec.isDetailFieldsForm);
  }

  public isInstanceCountChartForm(formSpec?: LMFormSpec): boolean {
    return (formSpec && formSpec.busFormSpec.formType === LMFormType.CHART);
  }

  public isMatrixForm(formSpec?: LMFormSpec): boolean {
    return (formSpec && formSpec.busFormSpec.formType === LMFormType.MATRIX);
  }

  public isCodeBlockFilter(formSpec?: LMFormSpec): boolean {
    return (formSpec && formSpec.busFormSpec && formSpec.busFormSpec.hasOwnProperty('codeBlockFieldId'));
  }

  public isMenuLayoutForm(formSpec?: LMFormSpec): boolean {
    return (formSpec && formSpec.busFormSpec.formType === LMFormType.MENU);
  }

  public isReadOnlyForm(formSpec?: LMFormSpec): boolean {
    return (formSpec && formSpec.isReadOnly === true) || this.lmContextService.inMingleWidget();
  }

  public isResponseRequired(formSpec?: LMFormSpec): boolean {
    return (formSpec && formSpec.busFormSpec.subFormType
      && formSpec.busFormSpec.subFormType === AppConstants.FORMSUBTYPE_RESPONSEREQD);
  }

  public isPageContextForm(formSpec: LMFormSpec): boolean {
    return (formSpec && formSpec.busFormSpec && formSpec.busFormSpec.formType === LMFormType.PAGE_CONTEXT);
  }

  public isSearchForm(formSpec?: LMFormSpec): boolean {
    return (formSpec && formSpec.busFormSpec && formSpec.busFormSpec.formType === LMFormType.SEARCH
      && !(formSpec.busFormSpec.panelNavigation || formSpec.busFormSpec.isWizard));
  }

  public isCubeSearchForm(formSpec?: LMFormSpec): boolean {
    return this.isSearchForm(formSpec) && formSpec.busFormSpec.subFormType === AppConstants.FORMSUBTYPE_CUBESEARCHFORM;
  }

  public isStandardForm(formSpec?: LMFormSpec): boolean {
    return (formSpec
      && (formSpec.busFormSpec.formType === LMFormType.STANDARD
        || formSpec.busFormSpec.formType === LMFormType.ACTION)
      && !(formSpec.busFormSpec.panelNavigation || formSpec.busFormSpec.isWizard))
      && !this.isActionFormWithSections(formSpec);
  }

  public isStepProcessForm(formSpec?: LMFormSpec): boolean {
    return (formSpec && formSpec.busFormSpec.formType === LMFormType.COMPOSITE
      && (formSpec.busFormSpec.panelNavigation || formSpec.busFormSpec.isWizard));
  }

  public isSubForm(formSpec?: LMFormSpec): boolean {
    return (formSpec && formSpec.busFormSpec.subFormType
      && formSpec.busFormSpec.subFormType === AppConstants.BUTTON_TYPE_SUBFORM
    );
  }

  public isTemplateTarget(formSpec: LMFormSpec): boolean {
    return (formSpec && formSpec.isTemplateForm);
  }

  public originalCompactFieldLayout(formSpec?: LMFormSpec): LMCompoundFieldLayout  {
    return formSpec && formSpec.busFormSpec ? formSpec.busFormSpec.originalCompoundFieldLayout : null;
  }

  public storageKey(formSpec?: LMFormSpec): string {
    // NOTE: if the storageKey is undefined, then use this pattern; needs to be the same as UrlUtils.java > buildStorageKeyTemplate()
    return (formSpec && formSpec.storageKey)
      ? formSpec.storageKey
      : this.lmContextService.getUrlPdlOrDa() + '_{resourceId}_{contextResourceId}_' + this.lmContextService.getActorId();
  }

  public includeFormPaging(dataView: DataView): boolean {
    return (dataView
      && dataView.hasOwnProperty('pagingInfo')
      && dataView.hasOwnProperty('includeFormPaging'));
    // && dataView.includeFormPaging);
  }

  // determine if large icons are being used on a menu
  public isLargeMenuScale(formSpec?: LMFormSpec): boolean {
    if (formSpec?.busFormSpec?.busFormLayoutSpec?.layout) {
      return !!formSpec.busFormSpec.busFormLayoutSpec.layout.isLargeScaleMenu;
    }
    return false;
  }
}
